import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton loading state for the Episode Detail page.
 * Matches the actual EpisodeDetail.tsx layout structure.
 */
export const EpisodeDetailSkeleton: React.FC = () => {
  return (
    <>
      {/* Section 1: Episode Header Card */}
      <div className="max-w-content" style={{ paddingLeft: '32px', paddingRight: '32px', paddingTop: '20px' }}>
      <div className="bg-podcast rounded-lg border border-border border-l-[3px] border-l-primary shadow-sm" style={{ padding: '20px 24px 24px 24px' }}>
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3">
                <Skeleton className="w-10 h-10 rounded-lg shrink-0" />
                <Skeleton className="h-7 w-64" />
              </div>
              <div className="mt-2 ml-[52px]">
                <Skeleton className="h-5 w-28 rounded-full" />
              </div>
              <div className="mt-2 ml-[52px]">
                <Skeleton className="h-4 w-96" />
              </div>
            </div>
            <div className="shrink-0 ml-4 flex items-center gap-6">
              <Skeleton className="h-6 w-24 rounded-full" />
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
          </div>
      </div>
      </div>

      {/* Section 3: Action Bar - Full Bleed */}
      <div className="border-b border-border">
        <div className="max-w-content" style={{ paddingLeft: '32px', paddingRight: '32px' }}>
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-9 w-36 rounded-md" />
              <Skeleton className="h-9 w-28 rounded-md" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-9 rounded-md" />
              <div className="h-6 w-px bg-border" />
              <Skeleton className="h-9 w-9 rounded-md" />
              <Skeleton className="h-9 w-9 rounded-md" />
            </div>
          </div>
        </div>
      </div>

      {/* Section 4: Main Content */}
      <div className="max-w-content pb-8" style={{ paddingLeft: '32px', paddingRight: '32px', paddingTop: '24px' }}>
        {/* Status banner */}
        <div
          className="rounded-xl p-4 mb-6"
          style={{
            backgroundColor: 'var(--pm-bg-card)',
            border: '1px solid var(--pm-border-default)',
          }}
        >
          <div className="flex items-center gap-3">
            <Skeleton className="h-5 w-5 rounded-full" />
            <Skeleton className="h-5 w-48" />
          </div>
        </div>

        {/* Clips header */}
        <div className="flex items-center justify-between mb-4 pb-4 border-b border-white/10">
          <div className="flex items-center gap-3">
            <Skeleton className="h-6 w-14" />
            <Skeleton className="h-5 w-6 rounded-full" />
          </div>
          <Skeleton className="h-8 w-24 rounded-md" />
        </div>

        {/* Generic clip cards */}
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="rounded-xl flex items-center gap-4 p-4"
              style={{
                backgroundColor: 'var(--pm-bg-card)',
                border: '1px solid var(--pm-border-default)',
              }}
            >
              <Skeleton className="w-10 h-10 rounded shrink-0" />
              <div className="flex-1 min-w-0">
                <Skeleton className="h-4 w-3/4 mb-2" />
                <Skeleton className="h-3 w-1/3" />
              </div>
              <Skeleton className="h-6 w-20 rounded-full" />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EpisodeDetailSkeleton;
